<template>
    <div v-if="hasPerm('create')">        
        <v-sheet class="px-6 pt-6">
            <div class="container">
                <div class="d-flex flex-wrap justify-space-between mb-8">
                    <h5 class="ma-3 mb-0 d-flex flex">{{ ( createMode ? "Create a New Network" : "Edit Network" ) }}</h5>    
                    <div class="flex-1 text-right">
                        <v-btn
                            v-if="!createMode"
                            color="white"
                            style="color: black;"
                            class="ma-2"
                            :loading="loadingNearbyPlaces"
                            :disabled="loadingNearbyPlaces"
                            @click="refreshNearbyPlaces"
                        >
                            <v-icon class="pr-2">mdi-map-marker-radius</v-icon>
                            Update Nearby Places
                        </v-btn>
                        <v-btn v-if="!this.createMode" class="ma-2" dark color="success" :loading="loading" @click="save()">
                            <v-icon class="pr-2">mdi-content-save</v-icon>
                            Save
                        </v-btn>
                        <v-btn class="ma-2" dark color="success" :loading="loading" @click="save(true)">
                            <v-icon class="pr-2">mdi-content-save</v-icon>
                            Save & Close
                        </v-btn>
                    </div>
                </div>
            </div>
        </v-sheet>
        <v-row justify="center">     
            <!-- <v-form  v-model="editFormValid" ref="editForm">        -->
            <v-col cols="10" md="5">
                <e-info-card
                    title="Basic Info"
                    sub-title=""
                >
                    <template slot="basic-info-slot">     
                        <v-form  v-model="editFormValid" ref="editForm">
                            <v-list>
                                <v-list-item>
                                    <!-- <v-list-item-avatar>
                                        <img :src="''" alt="" />
                                    </v-list-item-avatar> -->                                                                                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Code" 
                                            v-model="code"
                                            outlined
                                            :readonly="!createMode"   
                                            :validate-on-blur="createMode"
                                            :rules="(createMode ? codeRules : [])"                                       
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>                                

                                <v-list-item>                                    
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Title" 
                                            v-model="title"
                                            :rules="firstNameRules"
                                            :validate-on-blur="createMode"
                                        /> 
                                    </v-list-item-content>                                
                                </v-list-item>

                                

                                

                                <v-list-item>                                    
                                    <v-list-item-content>
                                        <v-checkbox
                                            style="width: 500px;"
                                            class="ma-2"
                                            v-model="archived"
                                            label="Archive (Archived Networks are not available for Targeting on New Campaign Creation)"                                              
                                        />  
                                    </v-list-item-content>                                
                                </v-list-item>

                                <v-list-item>                                                             
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Description" 
                                            v-model="description"
                                            :rules="firstNameRules"
                                            :validate-on-blur="createMode"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="type"
                                            :items="type_items"                 
                                            label="Target Type" 
                                            item-text="selecttext"
                                            item-value="selectvalue"    
                                            :rules="firstNameRules"
                                            :validate-on-blur="createMode"                                                 
                                            :clearable="true"                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>                                
                                <v-list-item>                                    
                                    <v-list-item-content>
                                        <v-select                                                                     
                                            v-model="locations_ingestion_source"
                                            :items="['Kotsovolos Stores','ProductMe Locations']"
                                            label="Locations Ingestion Source"                                                                                                                                     
                                            :clearable="true"                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                    
                                    <v-list-item-content>
                                        <v-select                                                                     
                                            v-model="adpoints_ingestion_source"
                                            :items="['ProductMe Adpoints']"
                                            label="Adpoints Ingestion Source"                                                                                                                                     
                                            :clearable="true"                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                    
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Data Sync Api Key" 
                                            v-model="api_key"
                                            :append-icon="showkey ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="showkey ? 'text' : 'password'"                                            
                                            @click:append="showkey = !showkey"
                                        /> 
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                    
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Upload Asset Api Key" 
                                            v-model="api_key_upload_asset"
                                            :append-icon="showkey ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="showkey ? 'text' : 'password'"                                            
                                            @click:append="showkey = !showkey"
                                        /> 
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                    
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Auth Api Key" 
                                            v-model="api_key_auth"
                                            :append-icon="showkey ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="showkey ? 'text' : 'password'"                                            
                                            @click:append="showkey = !showkey"
                                        /> 
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item > 
                                    <v-list-item-content class="pt-0">
                                        <v-btn class="ma-2" dark color="info" :loading="loadingSync" @click="runSync">
                                            <v-icon class="pr-2">mdi-autorenew</v-icon>
                                            Run Sync
                                        </v-btn>
                                    </v-list-item-content>      
                                </v-list-item>  
                                <v-list-item v-if="!createMode && ['kots_stores'].includes(code)"> 
                                    <v-list-item-content class="pt-0">
                                        <v-btn class="ma-2" dark color="info" :loading="loadingSync" @click="runSync">
                                            <v-icon class="pr-2">mdi-autorenew</v-icon>
                                            Run Live Sync
                                        </v-btn>
                                    </v-list-item-content>      
                                </v-list-item>  
                                <v-list-item v-if="!createMode && ['kots_stores_product_range'].includes(code)"> 
                                    <v-list-item-content class="pt-0">
                                        <v-btn class="ma-2" dark color="info" :loading="loadingSync" @click="runSync">
                                            <v-icon class="pr-2">mdi-autorenew</v-icon>
                                            Run Live Sync
                                        </v-btn>
                                    </v-list-item-content>      
                                </v-list-item>  
                                <template v-for="(si, index) in syncInfo" >
                                    <v-alert v-if="si" :key="index"
                                        border="top"
                                        colored-border
                                        type="info"
                                        elevation="2"
                                    >
                                        <ul>
                                            <li>Downloaded: {{si.result.fetch_count}}</li>
                                            <li>Updated: {{si.result.update_count}}</li>
                                            <li>Added: {{si.add_count}}</li>
                                        </ul>                                    
                                    </v-alert>                                        
                                    <v-alert
                                        v-if="si && si.length>0" :key="index"
                                        border="right"
                                        colored-border
                                        type="error"
                                        elevation="2"
                                    >
                                        <ul>                                        
                                            <li v-for="(er, idx) in si.errors"  :key="idx" >{{er}}</li>                                        
                                        </ul>
                                    </v-alert> 
                                </template>                           
                            </v-list>  
                        </v-form>                      
                    </template>
                </e-info-card>
            </v-col>


            <v-col cols="10" md="5">
                <v-alert v-if="pctSumInvalid"
                    dense
                    border="left"
                    type="warning"
                >
                    Total allocation pct sum must be equal to <strong>100%</strong>. Please review the percentages values.
                </v-alert>
                <e-info-card
                    title="Ownership"
                    sub-title=""
                >
                    <template slot="basic-info-slot">
                        <v-list>
                            <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="network_owner"
                                            :items="network_owners_listitems"                 
                                            label="Network Owner"  
                                            :rules="DropdownRules" 
                                            :validate-on-blur="createMode"                                                                                                                                    
                                            :clearable="true"                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                    
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Owned Capacity Limit" 
                                            v-model.number="owned_capacity_pct"                                                                                                                                                                                                                                                        
                                        /> 
                                    </v-list-item-content>                                
                                </v-list-item>
                        </v-list>
                    </template>
                </e-info-card>
                <v-form  v-model="pctFormValid" ref="pctForm">
                <e-info-card
                    class="mt-4"
                    title="Targeted By"
                    sub-title=""
                >
                    <template slot="basic-info-slot">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th>Organization</th>
                                    <th>Capacity Limit %</th>                                    
                                    <th>&nbsp;</th>             
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="ru in targeting_rules" :key="ru.networkowner_id">
                                    <td>{{ getOptionDescription(networkOwnerOptions, ru.networkowner_id) }}</td>
                                    <td><v-text-field style="width: 100px;" :rules="requiredRules" v-model.number="ru.capacity_limit_pct" type="number"></v-text-field></td>                                    
                                    <td><v-btn icon small @click="removeAssociatedOrg(ru)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td>
                                </tr>
                            </tbody>
                            
                        </v-simple-table>
                        <organization-selector-dropdown @itemselected="addAssociatedOrg" :owner_id="network_owner"></organization-selector-dropdown>                        
                    </template>
                </e-info-card>
                </v-form>
            </v-col>
            <!-- </v-form> -->            
        </v-row>
        <!-- <base-card class="transparent">
            
        </base-card> -->
        <v-snackbar
            v-model="snackbar"
            :timeout="4000"
            top
            tile
            :color="snackbarColor + ' -accent-2'"            
            >
            {{ snackbarMessage }}
        </v-snackbar>
    </div>
</template>
<script>
import avatarGroupCard from '@/components/card/AvatarGroupCard';
import EInfoCard from '@/components/card/BasicInfoCard';
import {api, srvApi, PATH} from "src/api/index";
import { fieldNotEmpty, fieldMinLength, numberFieldNotEmpty } from "src/core/vuetify-validators.js";
import OrganizationSelectorDropdown from "@/components/core/OrganizationSelectorDropdown";
import { checkPerm } from "@/data/navigation";
import { getOptionDescription } from "@/core/ui-utils.js"

export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Network Edit'
    },
    components: {
        avatarGroupCard,
        EInfoCard,
        OrganizationSelectorDropdown
    },
    data() {
        return {            
            showkey: false,
            pctSumInvalid: false,
            code: '',
            title: '',
            api_key: '',
            api_key_upload_asset: '',
            api_key_auth: '',
            owned_capacity_pct: 0,
            locations_ingestion_source: '',
            adpoints_ingestion_source: '',
            network_owner: '',
            targeting_rules: [],
            archived: false,
            description: '',
            type: '',
            crud_code: '',
            disabled: false,
            //ui mechanics      
            createMode: false,                  
            invitationFormValid: true,
            editFormValid: true,   
            pctFormValid: true,         
            syncInfo: null,
            //error
            loading: false,
            loadingSync: false,
            loadingNearbyPlaces: false,
            snackbar: false,
            snackbarColor: 'green',
            snackbarMessage: '',
            error: '',

            networkOwnerOptions: [],

            //reference data    
            network_owners_listitems: [],                                         
            type_items: [
                        {
                            selectvalue: "physical",
                            selecttext: "Physical Devices",
                        },
                        {
                            selectvalue: "web",
                            selecttext: "Web Placement",
                        },
                        {
                            selectvalue: "static",
                            selecttext: "Offline Placement",
                        }                       
                    ],
            firstNameRules: [
                fieldNotEmpty,            
                (v) => fieldMinLength(v, 2)   
            ],
            DropdownRules: [
                fieldNotEmpty,            
                (v) => numberFieldNotEmpty(v, 1)   
            ],
            codeRules: [
                fieldNotEmpty,            
                (v) => fieldMinLength(v, 2)  
            ],
            requiredRules: [
                fieldNotEmpty                
            ],
            treeitems: [
        {
          id: 5,
          name: 'Country :',
          children: [
            {
              id: 6,
              name: 'Area :',
              children: [
                {
                  id: 7,
                  name: 'Store :',
                  children: [
                    { id: 8, name: 'Floor :' },
                    { id: 9, name: 'Section :' },
                  ],
                },
              ],
            }           
          ],
        },       
      ]
        }
    },
    computed: {
        status() {
            return (this.disabled) ? "Disabled" :
                    (this.invitation_code) ? "Invited" :
                    (this.activation_date === "" || this.activation_date == null) ? "Awaiting Activation" : "Active";                    
        }
    },    
    async created() {
        if(this.$route.params.code) {
            this.crud_code = this.$route.params.code;       
            this.createMode = false;     
        }
        else {            
            this.createMode = true;
        }

        const rsp = await api.adpoint.getInitData();
        this.networkOwnerOptions = rsp.data.networkOwnerOptions;
    },
    async mounted() {      
        
        const rspN = await api.networkowner.getAll();
        this.network_owners_listitems.push(...rspN.data);

        if(!this.createMode) {
            const rspB = await api.network.getOne(this.crud_code);
            if(rspB && rspB.data) {
                this.code = rspB.data.code;
                this.title = rspB.data.title;
                this.api_key = rspB.data.api_key;
                this.api_key_upload_asset = rspB.data.api_key_upload_asset;
                this.api_key_auth = rspB.data.api_key_auth;                
                this.owned_capacity_pct = rspB.data.owned_capacity_pct;
                this.locations_ingestion_source = rspB.data.configuration.sync.locations_ingestion_source;
                this.adpoints_ingestion_source = rspB.data.configuration.sync.adpoints_ingestion_source;
                this.network_owner = rspB.data.network_owner;
                this.targeting_rules = rspB.data.targeting_rules /*.map(r=>({...r, editMode: false})*/;
                this.archived = rspB.data.archived;
                this.description = rspB.data.description;
                this.type = rspB.data.type;            
            }            
            //console.log(JSON.stringify(rspN.data));
            //this.editFormValid = true;
        }          
    },
    methods: {      
        hasPerm(action=null, fragment=null) {
            return checkPerm("network", action, fragment);
        },  
        getOptionDescription,        
        async addAssociatedOrg(item) {
            const rsp = await srvApi.put(PATH.NETWORK_ADDTARGETINGORG + '/' + this.code, item);
            this.targeting_rules.splice(0, this.targeting_rules.length);
            this.targeting_rules.push(...rsp.data/*.map(r=>({...r, editMode: false}))*/);
        },
        async removeAssociatedOrg(item) {
            const rsp = await srvApi.put(PATH.NETWORK_REMOVETARGETINGORG + '/' + this.code, item);
            this.targeting_rules.splice(0, this.targeting_rules.length);
            this.targeting_rules.push(...rsp.data/*.map(r=>({...r, editMode: false}))*/);
        },
        runSync() {
            this.loadingSync = true;  
            
            //setTimeout(() => this.loadingSync = false, 2000);
            
            api
            .network
            .runSync(this.code)
            .then((rsp)=>{
                this.syncInfo = rsp.data;
                //alert(JSON.stringify(rsp.data));
            })
            .catch((error)=>{
                //this.error = error.response.data.message;
                // this.snackbarColor = "red";
                // this.snackbarMessage = error.response.data.message;
                // this.snackbar = true;
            })
            .finally(()=>{
                this.loadingSync = false;
            })
                
        },
        async refreshNearbyPlaces() {
            if(this.createMode || this.loadingNearbyPlaces) {
                return;
            }
            this.loadingNearbyPlaces = true;
            try {
                const rsp = await api.network.refreshNearbyPlaces(this.crud_code);
                const payload = rsp?.data || {};
                const total = payload.totalLocations ?? 0;
                const updated = payload.updatedLocations ?? 0;
                const failed = payload.failedLocations ?? 0;
                this.snackbarColor = failed > 0 ? "orange" : "green";
                this.snackbarMessage = `Nearby places updated for ${updated}/${total} locations${failed > 0 ? `, ${failed} failed.` : ''}`;
                this.snackbar = true;
            }
            catch(error) {
                this.snackbarColor = "red";
                this.snackbarMessage = error?.response?.data?.message || "Failed to update nearby places.";
                this.snackbar = true;
            }
            finally {
                this.loadingNearbyPlaces = false;
            }
        },
        validateTotalCapacityAllocation() {
            let totalAllocation = 0;
            //add owner
            totalAllocation += this.owned_capacity_pct;
            //add other organizations
            totalAllocation += this.targeting_rules.reduce((a, b) => a + (b.capacity_limit_pct || 0), 0);
            //if larger than 100
            if(totalAllocation!=100) {
                this.snackbarColor = "red";
                this.snackbarMessage = "Total allocation sum must be equal 100%";
                this.snackbar = true;
                return false;
            }
            return true;
        },
        save(close=false) {
            this.error = '';     
            this.$refs.editForm.validate();       
            this.$refs.pctForm.validate();
            if(!this.validateTotalCapacityAllocation()) {
                this.pctSumInvalid = true;
                return;
            }                   
            else {
                this.pctSumInvalid = false;
            }
            if(!this.editFormValid || !this.pctFormValid) {                
                this.snackbarColor = "red";
                this.snackbarMessage = "There are invalid fields.";
                this.snackbar = true;
                return;
            }                                
            this.loading = true;   
            if(this.createMode) {
                api.network.create({      
                    code: this.code,                          
                    title: this.title,
                    archived: this.archived,
                    api_key: this.api_key,
                    api_key_upload_asset: this.api_key_upload_asset,
                    api_key_auth: this.api_key_auth,
                    owned_capacity_pct: this.owned_capacity_pct,
                    configuration: {
                        sync: {
                            locations_ingestion_source: this.locations_ingestion_source,
                            adpoints_ingestion_source: this.adpoints_ingestion_source,
                        }
                    },                     
                    network_owner: this.network_owner,
                    targeting_rules: this.targeting_rules,
                    description: this.description,
                    type: this.type,              
                })
                .then((rsp)=>{               
                    //this.$router.push("/mng/system/users/edit/" + rsp.data.code);  
                    //this.$router.push({ name: "system-users-edit", params: {code: rsp.data.code}});
                    // this.snackbarColor = "green";
                    // this.snackbarMessage = "User updated successfully";
                    // this.snackbar = true;                      
                    if(close) {
                        this.$router.push("/mng/adpoints/networks/");
                    }
                    else {
                        this.snackbarColor = "green";
                        this.snackbarMessage = "Adpoint saved successfully";
                        this.snackbar = true;                                     
                    }
                    //  if(close) {
                        
                    // }
                    // else {
                    //     this.snackbarColor = "green";
                    //     this.snackbarMessage = "Adpoint saved successfully";
                    //     this.snackbar = true;                                     
                    // }
                })
                .catch((error)=>{
                    //this.error = error.response.data.message;
                    this.snackbarColor = "red";
                    this.snackbarMessage = error.response.data.message;
                    this.snackbar = true;
                })
                .finally(()=>{
                    this.loading = false;                    
                })
            }  
            else {
                api.network.update(this.crud_code, {                                
                    title: this.title,
                    archived: this.archived,
                    description: this.description,
                    api_key: this.api_key,
                    api_key_upload_asset: this.api_key_upload_asset,
                    api_key_auth: this.api_key_auth,
                    owned_capacity_pct: this.owned_capacity_pct,
                    configuration: {
                        sync: {
                            locations_ingestion_source: this.locations_ingestion_source,
                            adpoints_ingestion_source: this.adpoints_ingestion_source,
                        }
                    },                    
                    network_owner: this.network_owner,
                    targeting_rules: this.targeting_rules,
                    type: this.type,               
                })
                .then((rsp)=>{               
                    //this.$router.push("/mng/system/users/edit/" + rsp.data.code);  
                    //this.$router.push({ name: "system-users-edit", params: {code: rsp.data.code}});
                    // this.snackbarColor = "green";
                    // this.snackbarMessage = "User updated successfully";
                    // this.snackbar = true;                      
                    if(close) {
                        this.$router.push("/mng/adpoints/networks/");
                    }
                    else {
                        this.snackbarColor = "green";
                        this.snackbarMessage = "Adpoint saved successfully";
                        this.snackbar = true;                                     
                    }
                    
                })
                .catch((error)=>{
                    //this.error = error.response.data.message;
                    this.snackbarColor = "red";
                    this.snackbarMessage = error.response.data.message;
                    this.snackbar = true;
                })
                .finally(()=>{
                    this.loading = false;
                })
            }                 
        },       
    }
}
</script>
<style lang="scss">
.ul-widget-profile-img {
    position: relative;
}
.ul-widget-profile-img:after {
    // content: "";
    // position: absolute;
    // top: 44px;
    // left: 50%;
    // width: 1px;
    // height: calc(100% - 30px);
    // background: #B3C0CE;
    content: '';
    position: absolute;
    top: 44px;
    left: 50%;
    width: 1px;
    height: calc(100% - 30px);
    background: #b3c0ce;
}
</style>
